<template>
  <event-list
    :extra="extra"
    :title="title"
    :types="types"
  ></event-list>
</template>

<script>
import EventList from '@/components/EventList'
import MetaInfoBuilder from '@/utils/social'
import {oldEvents} from '@/views/events/events'

export default {
  components: {
    EventList,
  },
  data: () => ({
    extra: oldEvents
      .filter((event) => event.type === 'supperclub'),
    title: 'Supperclubs',
    types: ['supperclub'],
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description(this.title)
      .title(this.title)
      .build()
  }
}
</script>
